import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import Sorteio from "./pages/Sorteio";
import MedicalRecord from "./pages/MedicalRecord";

export default function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/sorteio" element={<Sorteio />} />
        <Route path="/prontuario" element={<MedicalRecord />} />
      </Routes>
    </Router>
  );
}
